import clone from 'clone';
import { IAdminUploadService } from './IAdminUploadService';
import BaseServie from '@/services/baseService';
import { AxiosResponse } from 'axios';
import { LieferantDetailApiDto } from '@/api-schema';
import { LieferantDokumentUploadDto } from '@/types/LieferantDokumentUploadDto';

export class AdminUploadService extends BaseServie implements IAdminUploadService {
    private RESOURCE_URL: string;
    private UPLOAD_URL: string;
    private LIEFERANT_URL: string;
    constructor() {
        super();
        this.RESOURCE_URL = `${this.BASE_URL}dokumente`;
        this.UPLOAD_URL = `${this.RESOURCE_URL}/upload/lieferant`;
        this.LIEFERANT_URL = `${this.BASE_URL}teilnehmer/lieferant`;

        console.debug('ArchivService::constructor', this.RESOURCE_URL);
    }

    async getDokumentTypen(): Promise<Array<string>> {
        return super.GET<Array<string>>(`${this.UPLOAD_URL}`).then((response) => {
            return response;
        });
    }

    async uploadDokument(dokument: LieferantDokumentUploadDto, onUploadProgress?: (progressEvent: any) => void): Promise<AxiosResponse<any>> {
        const formData = new FormData();
        formData.append('dokument.datei', dokument.datei);
        formData.append('dokument.dokumentKategorie', dokument.dokumentKategorie);
        formData.append('dokument.dokumentTyp', dokument.dokumentTyp);
        formData.append('dokument.teilnehmerId', dokument.teilnehmerId);
        formData.append('dokument.titel', dokument.titel);
        // clonen damit nicht ursprüngliche Configs überschrieben werden
        const config = clone(this.uploadConfig);
        if (onUploadProgress) {
            config.onUploadProgress = onUploadProgress;
        }
        return super.POST<FormData>(`${this.UPLOAD_URL}`, formData, config).then((response) => {
            return response;
        });
    }

    async getLieferantDetails(lieferantenNummer: string): Promise<LieferantDetailApiDto> {
        return super.GET<LieferantDetailApiDto>(`${this.LIEFERANT_URL}/` + lieferantenNummer).then((response) => {
            return response;
        });
    }
}

export const adminUploadService = new AdminUploadService();
